import {createRoot}  from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import App from './components/app'
import { ToastrProvider } from './widgets/ToastrContext';
import '@progress/kendo-theme-default/dist/default-main-dark.css';
import './index.css'
import { Provider } from "react-redux";
import configureStore from "./store";
import AuthService from './utils/authService';
import { silentLogin } from './actions/admin';
import $ from 'jquery';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import axios from 'axios';

// Global 401 handler: when the token expires, clear the session and force the
// user back to the login screen. Avoids the blank-screen state on direct URLs.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            try { localStorage.removeItem('id_token'); } catch (e) {}
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const store = configureStore();

// Configure React Query
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 2,      // 2 minutes
            gcTime: 1000 * 60 * 10,        // 10 minutes (formerly cacheTime)
            refetchOnWindowFocus: false,
        },
    },
});

if (AuthService.loggedIn()) {
    store.dispatch(silentLogin(true)); 
};

root.render(
    
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <ToastrProvider>
                    <Router>            
                        <App />
                    </Router>
                </ToastrProvider>
            </QueryClientProvider>
        </Provider>
   
       
)